/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import omit from 'lodash/omit'
import { Image as SemanticImage } from 'semantic-ui-react'
import {
  createDynamicStyle,
  getDeepValue,
  attachStyle,
} from 'cms/helpers/styledComponents'
const COMPONENT = 'captionImage'

const createCssByPosition = (captionPosition, spacing = '1.5em') => {
  switch (captionPosition) {
    case 'topLeft':
      return {
        top: spacing,
        left: spacing,
        textAlign: 'left',
      }
    case 'topRight':
      return {
        top: spacing,
        right: spacing,
        textAlign: 'right',
      }
    case 'bottomLeft':
      return {
        bottom: spacing,
        left: spacing,
        textAlign: 'left',
      }
    case 'bottomRight':
      return {
        bottom: spacing,
        right: spacing,
        textAlign: 'right',
      }
    default:
      return {
        top: '50%',
        left: '50%',
        textAlign: 'center',
        transform: 'translate(-50%, -50%)',
      }
  }
}

const Wrapper = styled.div`
  ${({
  onClick,
  inline,
  captionPosition,
  isZoomWhenHovered,
  captionAppearWhenHovered,
  theme,
}) => ({
  ...createDynamicStyle(theme, 'cms', COMPONENT, 'wrapper')(),
  ...attachStyle(inline, { display: 'inline-block' }),
  '&:hover': {
    ...attachStyle(onClick, { cursor: 'pointer' }),
    '& img': {
      ...attachStyle(isZoomWhenHovered, createDynamicStyle(theme, 'cms', COMPONENT, 'imageEffect')()),
    },
  },
  '& .caption-cover': {
    ...createDynamicStyle(theme, 'cms', COMPONENT, 'captionCover')(),
    '& span': createDynamicStyle(theme, 'cms', COMPONENT, 'caption')({
      mobile: createCssByPosition(
        captionPosition,
        getDeepValue(theme, 'cms', COMPONENT, 'gutter', 'mobile'),
      ),
      tablet: createCssByPosition(
        captionPosition,
        getDeepValue(theme, 'cms', COMPONENT, 'gutter', 'tablet'),
      ),
      desktop: createCssByPosition(
        captionPosition,
        getDeepValue(theme, 'cms', COMPONENT, 'gutter', 'desktop'),
      ),
      ...attachStyle(captionAppearWhenHovered, { opacity: 0 }),
    }),
  },
})}
`

const createImageStyle = (style) => {
  const wrapperStyle = {
    ...omit(style, [
      'objectFit', 'objectPositionX', 'objectPositionY', 'verticalImageAlign'
    ]),
    ...style.verticalImageAlign && {
      display: 'flex',
    },
    ...style.verticalImageAlign === 'topLeft' && {
      justifyContent: 'flex-start', alignItems: 'flex-start',
    },
    ...style.verticalImageAlign === 'topRight' && {
      justifyContent: 'flex-end', alignItems: 'flex-start',
    },
    ...style.verticalImageAlign === 'center' && {
      justifyContent: 'center', alignItems: 'center',
    },
    ...style.verticalImageAlign === 'bottomLeft' && {
      justifyContent: 'flex-start', alignItems: 'flex-end',
    },
    ...style.verticalImageAlign === 'bottomRight' && {
      justifyContent: 'flex-end', alignItems: 'flex-end',
    },
  }
  const hasObjectFit = style.objectFit && style.objectFit !== '-'
  return {
    imageStyle: {
      ...hasObjectFit && {
        objectFit: style.objectFit,
        objectPosition: `${
          style.objectPositionX >= 0 ? style.objectPositionX : 50
        }% ${
          style.objectPositionY >= 0 ? style.objectPositionY : 50
        }%`
      },
      ...style.width === '100%' && { width: '100%' },
      ...(style.height === '100%' || hasObjectFit ) && { height: '100%' },
    },
    wrapperStyle,
  }
}

const Image = ({
  src = '',
  onClick,
  defaultImage,
  style,
  isZoomWhenHovered,
  inline,
  caption,
  captionPosition,
  captionAppearWhenHovered,
}) => {
  const { imageStyle, wrapperStyle } = createImageStyle(style)
  return (
    <Wrapper
      role={'presentation'}
      {...onClick && { onClick }}
      inline={inline}
      style={wrapperStyle}
      captionPosition={captionPosition}
      isZoomWhenHovered={isZoomWhenHovered}
      captionAppearWhenHovered={captionAppearWhenHovered}
    >
      <SemanticImage
        alt={''}
        src={src}
        style={imageStyle}
        onError={(e) => {
          e.target.src = defaultImage
        }}
      />
      {caption && (
        <a className="caption-cover">
          <span>{caption}</span>
        </a>
      )}
    </Wrapper>
  )
}

Image.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  fluid: PropTypes.bool,
  centered: PropTypes.bool,
  bordered: PropTypes.bool,
  inline: PropTypes.bool,
  style: PropTypes.object,
  size: PropTypes.oneOf(['mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive']),
  defaultImage: PropTypes.string,
  onClick: PropTypes.func,
  caption: PropTypes.string,
  captionPosition: PropTypes.oneOf(['topLeft', 'topRight', 'bottomLeft', 'bottomRight', 'middleCenter']),
  isZoomWhenHovered: PropTypes.bool,
  captionAppearWhenHovered: PropTypes.bool,
  imageStyle: PropTypes.object,
  wrapperStyle: PropTypes.object,
}
Image.defaultProps = {
  className: '',
  alt: 'image',
  fluid: false,
  centered: false,
  bordered: false,
  inline: false,
  size: undefined,
  style: {},
  caption: '',
  captionPosition: 'bottomLeft',
  defaultImage: '/static/image/default/no-image.jpg',
  onClick: null,
  isZoomWhenHovered: false,
  captionAppearWhenHovered: false,
  imageStyle: {},
  wrapperStyle: {},
}

export default Image



// WEBPACK FOOTER //
// ./src/cms/CmsCaptionImage.js